const StartSequenceGame = async (configData) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Sequence/Start`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(configData)
        });
        if (!response.ok) {
            const error = await response.json().catch(() => ({}));
            return { success: false, message: error.message || 'Error al iniciar secuencias.' };
        }
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de red al conectar con el servidor.' };
    }
};

const RegisterSequenceTap = async (screenId, matchId, colorId) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Sequence/Tap?screenId=${screenId}&matchId=${matchId}&colorId=${colorId}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        });
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false };
    }
};

const FinishSequencePlayback = async (screenId, matchId) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Sequence/FinishPlayback?screenId=${screenId}&matchId=${matchId}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        });
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false };
    }
};

const ResetSequenceGame = async (screenId) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Sequence/Reset?screenId=${screenId}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        });
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false };
    }
};

const GetSequenceState = async (screenId) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Sequence/State?screenId=${screenId}`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        });
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false };
    }
};

const ShowSequenceFrontPage = async (screenId) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Sequence/ShowFrontPage?screenId=${screenId}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        });
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false };
    }
};

const GetSequenceHistory = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Sequence/History`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        });
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false };
    }
};

const ClearSequenceHistory = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Sequence/History`, {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' }
        });
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false };
    }
};

const ProjectSequenceGame = async (screenId) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Sequence/ProjectGame?screenId=${screenId}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        });
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false };
    }
};

const GetSequenceThemes = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Sequence/GetThemes`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        });
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data: data.data };
    } catch (error) {
        return { success: false };
    }
};

const GetSequenceTheme = async (id) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Sequence/GetTheme/${id}`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        });
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data: data.data };
    } catch (error) {
        return { success: false };
    }
};

const SaveSequenceTheme = async (theme) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Sequence/SaveTheme`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(theme)
        });
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data: data.data };
    } catch (error) {
        return { success: false };
    }
};

const DeleteSequenceTheme = async (id) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Sequence/DeleteTheme/${id}`, {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' }
        });
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false };
    }
};

const GetSequenceConfig = async (screenId) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Sequence/GetConfig/${screenId}`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        });
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data: data.data };
    } catch (error) {
        return { success: false };
    }
};

const SaveSequenceConfig = async (config) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Sequence/SaveConfig`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(config)
        });
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false };
    }
};

const UploadSequenceMedia = async (file) => {
    try {
        const formData = new FormData();
        formData.append('file', file);

        const response = await fetch(`${process.env.REACT_APP_API_URL}Sequence/UploadMedia`, {
            method: 'POST',
            body: formData
        });
        if (!response.ok) return { success: false, message: 'Error de respuesta' };
        const data = await response.json();
        return data;
    } catch (error) {
        return { success: false, message: 'Error de conexión' };
    }
};

export { 
    StartSequenceGame, 
    RegisterSequenceTap, 
    FinishSequencePlayback, 
    ResetSequenceGame, 
    GetSequenceState, 
    ShowSequenceFrontPage, 
    GetSequenceHistory, 
    ClearSequenceHistory,
    ProjectSequenceGame,
    GetSequenceThemes,
    GetSequenceTheme,
    SaveSequenceTheme,
    DeleteSequenceTheme,
    GetSequenceConfig,
    SaveSequenceConfig,
    UploadSequenceMedia
};
